/*
  Ulevi custom behaviour — loaded site-wide from layout/theme.liquid.

  Two helpers, both defensive:

  1. Direct add-to-cart for hand-built sections (forms carrying .ulh-atc and a
     data-payload attribute). Falls back to a normal form POST on any failure,
     so the buy path can never be worse than plain HTML.

  2. Repair of blank product-card button labels. products.product.add_to_cart
     and products.product.choose_options are empty strings in locales/ka.json,
     so Dawn renders buttons with no text. This fills only genuinely empty
     labels — once ka.json is corrected it finds nothing to do and stops
     mattering. On the English storefront it also replaces Georgian labels,
     because the en translation layer currently serves Georgian for these keys.
*/
(function () {
  'use strict';

  var IS_EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var LABELS = IS_EN
    ? { add: 'Add to cart', options: 'Choose options' }
    : { add: 'კალათაში დამატება', options: 'ვარიანტები' };
  var GEORGIAN = /[Ⴀ-ჿ]/;

  /* ---------- 1. Direct add-to-cart ---------- */

  function restore(btn, html) {
    btn.innerHTML = html;
    btn.disabled = false;
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.classList || !form.classList.contains('ulh-atc')) return;
    var payload = form.getAttribute('data-payload');
    if (!payload) return;

    var body;
    try { body = JSON.parse(payload); } catch (e) { return; }

    ev.preventDefault();
    var btn = form.querySelector('button');
    var original = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '…';

    var drawer = document.querySelector('cart-drawer');
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body),
      credentials: 'same-origin'
    })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (res) {
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(res); restore(btn, original); return; } catch (e) {}
        }
        window.location.href = '/cart';
      })
      .catch(function () {
        restore(btn, original);
        HTMLFormElement.prototype.submit.call(form);
      });
  }, false);

  /* ---------- 2. Blank button labels ---------- */

  function fixLabels() {
    var buttons = document.querySelectorAll('.quick-add__submit');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      if (btn.getAttribute('data-ul-labelled') === '1') continue;

      var text = btn.hasAttribute('data-sold-out-message') ? LABELS.add : LABELS.options;
      /* The label span is the one that is NOT the hidden sold-out message. */
      var span = btn.querySelector('span:not(.sold-out-message)');

      if (span) {
        var cur = span.textContent.trim();
        if (cur !== '' && !(IS_EN && GEORGIAN.test(cur))) continue;
        span.textContent = text;
      } else {
        /* Dawn emits the "choose options" label as a bare text node with no
           span, so there is nothing to fill — insert one before the spinner. */
        var direct = '';
        for (var n = 0; n < btn.childNodes.length; n++) {
          if (btn.childNodes[n].nodeType === 3) direct += btn.childNodes[n].nodeValue;
        }
        var curDirect = direct.trim();
        if (curDirect !== '' && !(IS_EN && GEORGIAN.test(curDirect))) continue;
        if (curDirect !== '') {
          for (var d = btn.childNodes.length - 1; d >= 0; d--) {
            if (btn.childNodes[d].nodeType === 3) btn.removeChild(btn.childNodes[d]);
          }
        }
        var el = document.createElement('span');
        el.textContent = text;
        btn.insertBefore(el, btn.firstChild);
      }
      btn.setAttribute('data-ul-labelled', '1');
    }
  }

  function run() { try { fixLabels(); } catch (e) {} }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* Cards are re-rendered by filtering, pagination and the cart drawer, so
     watch for new ones — throttled to one pass per frame. */
  if (window.MutationObserver) {
    var queued = false;
    try {
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; run(); });
      }).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }
})();
